import { render } from "./AdminReportsByLeads.vue?vue&type=template&id=4a5c02d8&scoped=true&ts=true&lang=pug"
import script from "./AdminReportsByLeads.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminReportsByLeads.vue?vue&type=script&lang=ts&setup=true"

import "./AdminReportsByLeads.vue?vue&type=style&index=0&id=4a5c02d8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5c02d8"]])

export default __exports__